module.exports = __webpack_public_path__ + "img/share1.d38b03e4.svg";